import { useState, useRef } from 'react';

const useRefState = (initialState) => {
	const [state, setState] = useState(initialState);
	const stateRef = useRef(initialState);
	return [
		state,
		(newState) => {
			stateRef.current = newState;
			setState(newState);
		},
		stateRef,
	];
};

export default useRefState;
